namespace Matrix.Data {
    export interface AccountForm {
        AccountCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        AccountTypeCode: FormatLookupEditor;
        AccountRoleCode: FormatLookupEditor;
        ManagerCode: FormatLookupEditor;
        BaseCurrencyCode: Serenity.LookupEditor;
        AssetClass: Serenity.StringEditor;
        Benchmark1: FormatServiceLookupEditor;
        Benchmark2: FormatServiceLookupEditor;
        InceptionDate: Serenity.DateEditor;
        TerminationDate: Serenity.DateEditor;
        InvestmentObjective: Serenity.StringEditor;
        PerformanceBenchmark1: FormatServiceLookupEditor;
        PerformanceBenchmark2: FormatServiceLookupEditor;
        PerformanceInceptionDate: Serenity.DateEditor;
        PerformanceTerminationDate: Serenity.DateEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        AccountGroups: Serenity.CheckLookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
        EffectiveFrom: Serenity.DateEditor;
    }

    export class AccountForm extends Serenity.PrefixedContext {
        static formKey = 'Data.Account';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountForm.init)  {
                AccountForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = FormatLookupEditor;
                var w2 = s.LookupEditor;
                var w3 = FormatServiceLookupEditor;
                var w4 = s.DateEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.CheckLookupEditor;
                var w7 = StaticTextBlock;
                var w8 = ReadOnlyDateTime;

                Q.initFormType(AccountForm, [
                    'AccountCode', w0,
                    'Name', w0,
                    'AccountTypeCode', w1,
                    'AccountRoleCode', w1,
                    'ManagerCode', w1,
                    'BaseCurrencyCode', w2,
                    'AssetClass', w0,
                    'Benchmark1', w3,
                    'Benchmark2', w3,
                    'InceptionDate', w4,
                    'TerminationDate', w4,
                    'InvestmentObjective', w0,
                    'PerformanceBenchmark1', w3,
                    'PerformanceBenchmark2', w3,
                    'PerformanceInceptionDate', w4,
                    'PerformanceTerminationDate', w4,
                    'DefaultSortOrder', w5,
                    'AccountGroups', w6,
                    'CreatedBy', w7,
                    'CreatedWhen', w8,
                    'UpdatedBy', w7,
                    'UpdatedWhen', w8,
                    'Version', w7,
                    'EffectiveFrom', w4
                ]);
            }
        }
    }
}
